import { Loader2 } from 'lucide-react';
import './Loading.css';

const Loading = ({ text = 'Yükleniyor...', size = 'medium', fullPage = false }) => {
  const sizeClass = `loading-${size}`;

  if (fullPage) {
    return (
      <div className="loading-fullpage">
        <div className="loading-container">
          <div className="loading-spinner-wrapper">
            <Loader2 className="loading-spinner-icon" />
            <div className="loading-ring"></div>
          </div>
          <p className="loading-text">{text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`loading-inline ${sizeClass}`}>
      <div className="loading-spinner-wrapper">
        <Loader2 className="loading-spinner-icon" />
        <div className="loading-ring"></div>
      </div>
      <p className="loading-text">{text}</p>
    </div>
  );
};

export default Loading;
